import * as UserActions from "./UserActions.js";
import {
  executeGraphQLRequest,
  createContext,
} from "../../../graphql/graphql-client";
import * as UserQueries from "../../../graphql/queries/user-queries.js";

export const fetchUser = (userId) => {
  return (dispatch, getState) => {
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: UserActions.fetchUserBegin,
        success: UserActions.fetchUserSuccess,
        failure: UserActions.fetchUserFailure,
      },
      UserQueries.GET_USER_BY_ID_QUERY,
      {
        id: { primaryId: userId },
        context: createContext(userId, "READ", "USER", userId),
      }
    );
  };
};
export const fetchDeposits = (organizationId, size, nextToken) => {
  return (dispatch, getState) => {
    let userId = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: UserActions.fetchOrganizationDepositsBegin,
        success: UserActions.fetchOrganizationDepositsSuccess,
        failure: UserActions.fetchOrganizationDepositsFailure,
      },
      UserQueries.GET_DEPOSITS_BY_ORGANIZATION_QUERY,
      {
        filter: { primaryId: organizationId},
        size: size,
        nextToken: nextToken,
        context: createContext(userId, "READ", "ORGANIZATION", organizationId),
      }
    );
  };
};
export const fetchOrganization = (organizationId) => {
  return (dispatch, getState) => {
    let userId = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: UserActions.fetchOrganizationBegin,
        success: UserActions.fetchOrganizationSuccess,
        failure: UserActions.fetchOrganizationFailure,
      },
      UserQueries.GET_ORGANIZATION_BY_ID_QUERY,
      {
        id: { primaryId: organizationId },
        context: createContext(userId, "READ", "ORGANIZATION", organizationId),
      }
    );
  };
};

export const fetchOrganizationStat = (organizationId) => {
  return (dispatch, getState) => {
    let userId = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: UserActions.fetchOrganizationStatBegin,
        success: UserActions.fetchOrganizationStatSuccess,
        failure: UserActions.fetchOrganizationStatFailure,
      },
      UserQueries.GET_ORGANIZATION_STAT_BY_ID_QUERY,
      {
        id: { primaryId: organizationId },
        context: createContext(
          userId,
          "READ",
          "ORGANIZATIONSTAT",
          organizationId
        ),
      }
    );
  };
}

export const  updateOrganization = (organization) => {
  return (dispatch, getState) => {
    let userId = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: UserActions.updateOrganizationBegin,
        success: UserActions.updateOrganizationSuccess,
        failure: UserActions.updateOrganizationFailure,
      },
      UserQueries.UPDATE_ORGANIZATION_MUTATION,
      {
        input: {name: organization.name},
        condition: { primaryId: organization.id },
        context: createContext(
          userId,
          "UPDATE",
          "ORGANIZATION",
          organization.id
        ),
      }
    );
  };
}

export const fetchOrgSubscription = (organizationId) => {
  return (dispatch, getState) => {
    let userId = getState().user.userId;
    executeGraphQLRequest(
      dispatch,
      getState,
      {
        begin: UserActions.fetchOrgSubscriptionBegin,
        success: UserActions.fetchOrgSubscriptionSuccess,
        failure: UserActions.fetchOrgSubscriptionFailure,
      },
      UserQueries.GET_ORGANIZATION_SUBSCRIPTION_QUERY,
      {
        id: { primaryId: organizationId },
        context: createContext(userId, "READ", "ORGANIZATIONSUBSCRIPTION", organizationId),
      }
    );
  };
};
